import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import {
  calculateDiscountForExistingSubscription,
  calculateTotals,
} from 'src/modules/subscriptions/calculatePrice';
import { calculateExpirationDate } from '@/modules/subscriptions/calculateExpirationDate';

export default function usePaymentForm({
  subscriptionType,
  existingSubscription,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      quantity: 1,
      quantityUnit: null,
      autoRenew: false,
      existingSubscriptionDiscount: 0,
      total: 0,
      totalWithoutDiscount: 0,
      quantityYears: 1,
      quantityMonths: 1,
      promotionCode: null,
    },
    actions: {
      setQuantity: (quantity, unit) => {
        actions.setState({ [`quantity${unit}`]: quantity });
      },
      setQuantityUnit: (quantityUnit) => {
        actions.setState({ quantityUnit });
      },
      setPromotionCode: (promotionCode) => {
        actions.setState({ promotionCode });
      },
      setAutoRenew: (autoRenew) => {
        actions.setState({ autoRenew });
      },
    },
  });

  useEffect(() => {
    if (state.quantityUnit) {
      const { total, totalWithoutDiscount } = calculateTotals({
        subscriptionType,
        quantityUnit: state.quantityUnit,
        quantity: state.quantity,
        promotionCode: state.promotionCode,
        existingSubscription,
      });
      actions.setState({
        total,
        totalWithoutDiscount,
        expirationDate: calculateExpirationDate({
          subscriptionType,
          quantityUnit: state.quantityUnit,
          quantity: state.quantity,
          existingSubscription,
        }),
      });
    }
  }, [
    subscriptionType,
    state.quantity,
    state.quantityUnit,
    state.promotionCode,
    existingSubscription,
  ]);

  useEffect(() => {
    const discount = calculateDiscountForExistingSubscription({
      subscriptionType,
      existingSubscription,
    });
    actions.setState({ existingSubscriptionDiscount: discount });
  }, [existingSubscription]);

  useEffect(() => {
    actions.setState({
      quantity:
        state.quantityUnit == 'year'
          ? state.quantityYears
          : state.quantityMonths,
    });
  }, [state.quantityUnit, state.quantityMonths, state.quantityYears]);

  return { state, actions };
}
